/* ==========================================================================
   ASURA — decant ABSCENTS de regalo elegido con cada perfume

   La elección es una propiedad de la línea del perfume en el carrito
   ("Decant de regalo"), que llega tal cual al pago y al pedido. Desde la
   ficha el perfume ya entra con "Sorpréndeme".
     Hoja de confirmación  tarjetas: al tocar una, se guarda en la línea del
                           perfume que se acaba de agregar
     Carrito               un selector por perfume para elegir o cambiar
   Las demás propiedades de la línea se conservan. Mientras se guarda un
   cambio, los botones de pago esperan.
   Marcado: snippets/asura-decants.liquid · Estilos: assets/asura-carrito-lateral.css
   ========================================================================== */
(function () {
  'use strict';

  if (window.asuraDecants) return;
  window.asuraDecants = true;

  var CLAVE = 'Decant de regalo';
  var SORPRESA = 'Sorpréndeme';
  var PAGAR = '.cart__checkout, .asura-hoja__pagar';

  function ruta(nombre, porDefecto) {
    return (window.theme && theme.routes && theme.routes[nombre]) || porDefecto;
  }

  function json(url, opciones) {
    return fetch(url, Object.assign({
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' }
    }, opciones)).then(function (r) {
      if (!r.ok) throw new Error('carrito ' + r.status);
      return r.json();
    });
  }

  /* ------------------------------------------------------------------------
     Guardar en la línea (en fila: un cambio a la vez; la clave de la línea
     cambia con cada propiedad nueva, así que se busca de nuevo en el carrito)
     ------------------------------------------------------------------------ */
  var fila = Promise.resolve();
  var pendientes = 0;

  function esperarPago(si) {
    document.querySelectorAll(PAGAR).forEach(function (b) {
      b.disabled = si;
      b.classList.toggle('asura-espera', si);
    });
  }

  function guardar(buscar, valor) {
    pendientes++;
    esperarPago(true);
    var trabajo = fila.then(function () {
      return json(ruta('cart', '/cart.js')).then(function (cart) {
        var item = buscar(cart.items || []);
        if (!item) return null;
        var props = Object.assign({}, item.properties || {});
        if (props[CLAVE] === valor) return item;
        props[CLAVE] = valor;
        return json(ruta('cartChange', '/cart/change.js'), {
          method: 'POST',
          body: JSON.stringify({ id: item.key, quantity: item.quantity, properties: props })
        }).then(function (nuevo) {
          return (nuevo.items || []).filter(function (i) {
            return i.variant_id === item.variant_id && i.properties && i.properties[CLAVE] === valor;
          })[0] || null;
        });
      });
    });
    fila = trabajo.catch(function () {});
    return trabajo.then(function (item) {
      fin();
      return item;
    }, function (e) {
      fin();
      throw e;
    });
  }

  function fin() {
    pendientes--;
    if (pendientes > 0) return;
    esperarPago(false);
    if (document.body.classList.contains('template-cart')) {
      window.location.reload();
    } else {
      document.dispatchEvent(new CustomEvent('cart:build'));
    }
  }

  /* ------------------------------------------------------------------------
     Hoja de confirmación
     ------------------------------------------------------------------------ */
  var linea = null;   // el perfume que se acaba de agregar: { key, variant_id }

  function marcar(caja, valor) {
    caja.querySelectorAll('[data-asura-decant]').forEach(function (b) {
      var si = b.getAttribute('data-asura-decant') === valor;
      b.classList.toggle('is-elegido', si);
      b.setAttribute('aria-checked', si ? 'true' : 'false');
    });
  }

  document.addEventListener('ajaxProduct:added', function (e) {
    if (!e.detail || !e.detail.product) return;
    var p = e.detail.product;
    linea = { key: p.key, variant_id: p.variant_id };
    var actual = (p.properties && p.properties[CLAVE]) || SORPRESA;
    document.querySelectorAll('[data-asura-decants]').forEach(function (caja) {
      marcar(caja, actual);
      var carril = caja.querySelector('.asura-decants__fila');
      if (carril) carril.scrollLeft = 0;
    });
  });

  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-asura-decants] [data-asura-decant]') : null;
    if (!b || !linea) return;
    var caja = b.closest('[data-asura-decants]');
    var valor = b.getAttribute('data-asura-decant');
    marcar(caja, valor);
    var meta = linea;
    guardar(function (items) {
      return items.filter(function (i) { return i.key === meta.key; })[0] ||
        items.filter(function (i) { return i.variant_id === meta.variant_id; })[0];
    }, valor).then(function (item) {
      if (item && linea === meta) linea = { key: item.key, variant_id: item.variant_id };
    }).catch(function () {});
  });

  // flechas para recorrer las tarjetas con teclado
  document.addEventListener('keydown', function (e) {
    var b = e.target.closest ? e.target.closest('[data-asura-decants] [data-asura-decant]') : null;
    if (!b || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
    var todos = Array.prototype.slice.call(b.parentNode.querySelectorAll('[data-asura-decant]'));
    var i = todos.indexOf(b) + (e.key === 'ArrowRight' ? 1 : -1);
    if (todos[i]) {
      e.preventDefault();
      todos[i].focus();
      todos[i].click();
    }
  });

  /* ------------------------------------------------------------------------
     Carrito: un selector por perfume
     ------------------------------------------------------------------------ */
  document.addEventListener('change', function (e) {
    var s = e.target;
    if (!s || !s.matches || !s.matches('[data-asura-decant-linea]')) return;
    var key = s.getAttribute('data-key');
    s.disabled = true;
    guardar(function (items) {
      return items.filter(function (i) { return i.key === key; })[0];
    }, s.value).catch(function () {
      s.disabled = false;
    });
  });
})();
